import { render, staticRenderFns } from "./BudgetProgramTemplate.vue?vue&type=template&id=122ee8ef&"
import script from "./BudgetProgramTemplate.vue?vue&type=script&lang=ts&"
export * from "./BudgetProgramTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports